export default [
    {
        path: '/pages/goods/storeOrderCartDetail',
        name: '/pages/goods/storeOrderCartDetail',
        component: () => import('@/views/goods/storeOrderCartDetail.vue')
    },
    {
        path: '/pages/goods/UpShopHouseDetail',
        name: '/pages/goods/UpShopHouseDetail',
        component: () => import('@/views/goods/UpShopHouseDetail.vue')
    },
    {
        path: '/pages/goods/upShopHouseInManage',
        name: '/pages/goods/upShopHouseInManage',
        component: () => import('@/views/goods/upShopHouseInManage.vue')
    },
    {
        path: '/pages/goods/upShopHouseManage',
        name: '/pages/goods/upShopHouseManage',
        component: () => import('@/views/goods/upShopHouseManage.vue')
    },
    {
        path: '/pages/goods/userExpeditingDelivery',
        name: '/pages/goods/userExpeditingDelivery',
        component: () => import('@/views/goods/userExpeditingDelivery.vue')
    },
    {
        path: '/pages/goods/shopSettingManage',
        name: '/pages/goods/shopSettingManage',
        component: () => import('@/views/goods/shopSettingManage.vue')
    },
    {
        path: '/pages/goods/shopVipUserAccount',
        name: '/pages/goods/shopVipUserAccount',
        component: () => import('@/views/goods/shopVipUserAccount.vue')
    },
    {
        path: '/pages/goods/shopVisitManage',
        name: '/pages/goods/shopVisitManage',
        component: () => import('@/views/goods/shopVisitManage.vue')
    },
    {
        path: '/pages/goods/shopCommunityManage',
        name: '/pages/goods/shopCommunityManage',
        component: () => import('@/views/goods/shopCommunityManage.vue')
    },
    {
        path: '/pages/goods/shopHouseManage',
        name: '/pages/goods/shopHouseManage',
        component: () => import('@/views/goods/shopHouseManage.vue')
    },
    {
        path: '/pages/goods/shopReturnAddressManage',
        name: '/pages/goods/shopReturnAddressManage',
        component: () => import('@/views/goods/shopReturnAddressManage.vue')
    },
    {
        path: '/pages/goods/sellingCostManage',
        name: '/pages/goods/sellingCostManage',
        component: () => import('@/views/goods/sellingCostManage.vue')
    },
    {
        path: '/pages/goods/shopAccountDetailManage',
        name: '/pages/goods/shopAccountDetailManage',
        component: () => import('@/views/goods/shopAccountDetailManage.vue')
    },
    {
        path: '/pages/goods/shopAccountManage',
        name: '/pages/goods/shopAccountManage',
        component: () => import('@/views/goods/shopAccountManage.vue')
    },
    {
        path: '/pages/goods/shopAppraiseManage',
        name: '/pages/goods/shopAppraiseManage',
        component: () => import('@/views/goods/shopAppraiseManage.vue')
    },
    {
        path: '/pages/goods/shopAuditManage',
        name: '/pages/goods/shopAuditManage',
        component: () => import('@/views/goods/shopAuditManage.vue')
    },
    {
        path: '/pages/goods/queryStockManage',
        name: '/pages/goods/queryStockManage',
        component: () => import('@/views/goods/queryStockManage.vue')
    },
    {
        path: '/pages/goods/queryWarnStock',
        name: '/pages/goods/queryWarnStock',
        component: () => import('@/views/goods/queryWarnStock.vue')
    },
    {
        path: '/pages/goods/recommendGoodsManage',
        name: '/pages/goods/recommendGoodsManage',
        component: () => import('@/views/goods/recommendGoodsManage.vue')
    },
    {
        path: '/pages/goods/resourceSupplierManage',
        name: '/pages/goods/resourceSupplierManage',
        component: () => import('@/views/goods/resourceSupplierManage.vue')
    },
    {
        path: '/pages/goods/sellingCostDetailManage',
        name: '/pages/goods/sellingCostDetailManage',
        component: () => import('@/views/goods/sellingCostDetailManage.vue')
    },
    {
        path: '/pages/goods/productPriceRuleManage',
        name: '/pages/goods/productPriceRuleManage',
        component: () => import('@/views/goods/productPriceRuleManage.vue')
    },
    {
        path: '/pages/goods/productSpecManage',
        name: '/pages/goods/productSpecManage',
        component: () => import('@/views/goods/productSpecManage.vue')
    },
    {
        path: '/pages/goods/productStockManage',
        name: '/pages/goods/productStockManage',
        component: () => import('@/views/goods/productStockManage.vue')
    },
    {
        path: '/pages/goods/publicWeChatManage',
        name: '/pages/goods/publicWeChatManage',
        component: () => import('@/views/goods/publicWeChatManage.vue')
    },
    {
        path: '/pages/goods/productDetail',
        name: '/pages/goods/productDetail',
        component: () => import('@/views/goods/productDetail.vue')
    },
    {
        path: '/pages/goods/productImport',
        name: '/pages/goods/productImport',
        component: () => import('@/views/goods/productImport.vue')
    },
    {
        path: '/pages/goods/productLabelManage',
        name: '/pages/goods/productLabelManage',
        component: () => import('@/views/goods/productLabelManage.vue')
    },
    {
        path: '/pages/goods/productManage',
        name: '/pages/goods/productManage',
        component: () => import('@/views/goods/productManage.vue')
    },
    {
        path: '/pages/goods/myHousekeepingDispatchManage',
        name: '/pages/goods/myHousekeepingDispatchManage',
        component: () => import('@/views/goods/myHousekeepingDispatchManage.vue')
    },
    {
        path: '/pages/goods/outOrderManage',
        name: '/pages/goods/outOrderManage',
        component: () => import('@/views/goods/outOrderManage.vue')
    },
    {
        path: '/pages/goods/PrintSmallOrder',
        name: '/pages/goods/PrintSmallOrder',
        component: () => import('@/views/goods/PrintSmallOrder.vue')
    },
    {
        path: '/pages/goods/productCategoryManage',
        name: '/pages/goods/productCategoryManage',
        component: () => import('@/views/goods/productCategoryManage.vue')
    },
    {
        path: '/pages/goods/groupBuyProductManage',
        name: '/pages/goods/groupBuyProductManage',
        component: () => import('@/views/goods/groupBuyProductManage.vue')
    },
    {
        path: '/pages/goods/GroupBuySettingManage',
        name: '/pages/goods/GroupBuySettingManage',
        component: () => import('@/views/goods/GroupBuySettingManage.vue')
    },
    {
        path: '/pages/goods/inoutOrderManage',
        name: '/pages/goods/inoutOrderManage',
        component: () => import('@/views/goods/inoutOrderManage.vue')
    },
    {
        path: '/pages/goods/labelManage',
        name: '/pages/goods/labelManage',
        component: () => import('@/views/goods/labelManage.vue')
    },
    {
        path: '/pages/goods/groupBuyBatchManage',
        name: '/pages/goods/groupBuyBatchManage',
        component: () => import('@/views/goods/groupBuyBatchManage.vue')
    },
    {
        path: '/pages/goods/groupBuyManage',
        name: '/pages/goods/groupBuyManage',
        component: () => import('@/views/goods/groupBuyManage.vue')
    },
    {
        path: '/pages/goods/getSalesInfoManage',
        name: '/pages/goods/getSalesInfoManage',
        component: () => import('@/views/goods/getSalesInfoManage.vue')
    },
    {
        path: '/pages/goods/getSalesRankingInfoManage',
        name: '/pages/goods/getSalesRankingInfoManage',
        component: () => import('@/views/goods/getSalesRankingInfoManage.vue')
    },
    {
        path: '/pages/goods/goldBusinessManage',
        name: '/pages/goods/goldBusinessManage',
        component: () => import('@/views/goods/goldBusinessManage.vue')
    },
    {
        path: '/pages/goods/goodCashier',
        name: '/pages/goods/goodCashier',
        component: () => import('@/views/goods/goodCashier.vue')
    },
    {
        path: '/pages/goods/finishHousekeepingPool',
        name: '/pages/goods/finishHousekeepingPool',
        component: () => import('@/views/goods/finishHousekeepingPool.vue')
    },
    {
        path: '/pages/goods/getInoutInfoManage',
        name: '/pages/goods/getInoutInfoManage',
        component: () => import('@/views/goods/getInoutInfoManage.vue')
    },
    {
        path: '/pages/goods/getInStockInfoManage',
        name: '/pages/goods/getInStockInfoManage',
        component: () => import('@/views/goods/getInStockInfoManage.vue')
    },
    {
        path: '/pages/goods/doOrderDetailOut',
        name: '/pages/goods/doOrderDetailOut',
        component: () => import('@/views/goods/doOrderDetailOut.vue')
    },
    {
        path: '/pages/goods/downShopHouseManage',
        name: '/pages/goods/downShopHouseManage',
        component: () => import('@/views/goods/downShopHouseManage.vue')
    },
    {
        path: '/pages/goods/downShopHouseOutManage',
        name: '/pages/goods/downShopHouseOutManage',
        component: () => import('@/views/goods/downShopHouseOutManage.vue')
    },
    {
        path: '/pages/goods/editProduct',
        name: '/pages/goods/editProduct',
        component: () => import('@/views/goods/editProduct.vue')
    },
    {
        path: '/pages/goods/feePrintSpecManage',
        name: '/pages/goods/feePrintSpecManage',
        component: () => import('@/views/goods/feePrintSpecManage.vue')
    },
    {
        path: '/pages/goods/couponShopPoolManage',
        name: '/pages/goods/couponShopPoolManage',
        component: () => import('@/views/goods/couponShopPoolManage.vue')
    },
    {
        path: '/pages/goods/distributionModeManage',
        name: '/pages/goods/distributionModeManage',
        component: () => import('@/views/goods/distributionModeManage.vue')
    },
    {
        path: '/pages/goods/DoAllocationOrderIn',
        name: '/pages/goods/DoAllocationOrderIn',
        component: () => import('@/views/goods/DoAllocationOrderIn.vue')
    },
    {
        path: '/pages/goods/DoOrderDetailIn',
        name: '/pages/goods/DoOrderDetailIn',
        component: () => import('@/views/goods/DoOrderDetailIn.vue')
    },
    {
        path: '/pages/goods/centralizedPurchase',
        name: '/pages/goods/centralizedPurchase',
        component: () => import('@/views/goods/centralizedPurchase.vue')
    },
    {
        path: '/pages/goods/chainInoutOrderManage',
        name: '/pages/goods/chainInoutOrderManage',
        component: () => import('@/views/goods/chainInoutOrderManage.vue')
    },
    {
        path: '/pages/goods/chainSupplier',
        name: '/pages/goods/chainSupplier',
        component: () => import('@/views/goods/chainSupplier.vue')
    },
    {
        path: '/pages/goods/couponDetailManage',
        name: '/pages/goods/couponDetailManage',
        component: () => import('@/views/goods/couponDetailManage.vue')
    },
    {
        path: '/pages/goods/couponShopPoolDetailManage',
        name: '/pages/goods/couponShopPoolDetailManage',
        component: () => import('@/views/goods/couponShopPoolDetailManage.vue')
    },
    {
        path: '/pages/goods/buyGoldSend',
        name: '/pages/goods/buyGoldSend',
        component: () => import('@/views/goods/buyGoldSend.vue')
    },
    {
        path: '/pages/goods/buyGoldSendParking',
        name: '/pages/goods/buyGoldSendParking',
        component: () => import('@/views/goods/buyGoldSendParking.vue')
    },
    {
        path: '/pages/goods/AssetInventoryInStock',
        name: '/pages/goods/AssetInventoryInStock',
        component: () => import('@/views/goods/AssetInventoryInStock.vue')
    },
    {
        path: '/pages/goods/assetInventoryManage',
        name: '/pages/goods/assetInventoryManage',
        component: () => import('@/views/goods/assetInventoryManage.vue')
    },
    {
        path: '/pages/goods/buyGold',
        name: '/pages/goods/buyGold',
        component: () => import('@/views/goods/buyGold.vue')
    },
    {
        path: '/pages/goods/applyReturnOrderrCartManage',
        name: '/pages/goods/applyReturnOrderrCartManage',
        component: () => import('@/views/goods/applyReturnOrderrCartManage.vue')
    },
    {
        path: '/pages/goods/AssetInventoryEdit',
        name: '/pages/goods/AssetInventoryEdit',
        component: () => import('@/views/goods/AssetInventoryEdit.vue')
    },
    {
        path: '/pages/goods/assetInventoryIn',
        name: '/pages/goods/assetInventoryIn',
        component: () => import('@/views/goods/assetInventoryIn.vue')
    },
    {
        path: '/pages/goods/allocationOrderIn',
        name: '/pages/goods/allocationOrderIn',
        component: () => import('@/views/goods/allocationOrderIn.vue')
    },
    {
        path: '/pages/goods/allocationOrderManage',
        name: '/pages/goods/allocationOrderManage',
        component: () => import('@/views/goods/allocationOrderManage.vue')
    },
    {
        path: '/pages/goods/ApplyReturnOrderManage',
        name: '/pages/goods/ApplyReturnOrderManage',
        component: () => import('@/views/goods/ApplyReturnOrderManage.vue')
    },
    {
        path: '/pages/goods/AccountBankManage',
        name: '/pages/goods/AccountBankManage',
        component: () => import('@/views/goods/AccountBankManage.vue')
    },
    {
        path: '/pages/goods/AccountBondObjManage',
        name: '/pages/goods/AccountBondObjManage',
        component: () => import('@/views/goods/AccountBondObjManage.vue')
    },
    {
        path: '/pages/goods/accountWithdrawalApplyManage',
        name: '/pages/goods/accountWithdrawalApplyManage',
        component: () => import('@/views/goods/accountWithdrawalApplyManage.vue')
    },
    {
        path: '/pages/goods/addProduct',
        name: '/pages/goods/addProduct',
        component: () => import('@/views/goods/addProduct.vue')
    },
    {
        path: '/pages/goods/adminProduct',
        name: '/pages/goods/adminProduct',
        component: () => import('@/views/goods/adminProduct.vue')
    },
    {
        path: '/pages/goods/mainCategoryProduct',
        name: '/pages/goods/mainCategoryProduct',
        component: () => import('@/views/goods/mainCategoryProduct.vue')
    },
    {
        path: '/pages/goods/mainCategoryManage',
        name: '/pages/goods/mainCategoryManage',
        component: () => import('@/views/goods/mainCategoryManage.vue')
    },
] 